import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/balanco/form_cad'


function CadastrarBalancoScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Balanço - Módulo de Balanços" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarBalancoScreen;